import { makeAutoObservable, runInAction } from 'mobx';

import { getStripePriceOpenDataConfig } from './api';
import normalizePricingData from './helpers/functions/config';
import { PricingConfig } from './types/config';
import { logError } from '../../helpers/functions/api';
import { BaseRootStore } from '../rootStore/baseRootStore';

export default class PriceConfigStore<IRootStore extends BaseRootStore> {
  rootStore: IRootStore;

  config: PricingConfig | null = null;

  loading = false;

  error: Error | null = null;

  constructor(rootStore: IRootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  get loaded() {
    return !!this.config;
  }

  reset() {
    runInAction(() => {
      this.config = null;
      this.loading = false;
      this.error = null;
    });
  }

  async fetchConfig() {
    if (this.loaded || this.loading) {
      return;
    }

    this.loading = true;
    this.error = null;

    try {
      const { data } = await getStripePriceOpenDataConfig();

      if (!data?.getStripePriceOpenDataConfig) {
        throw new Error('[PriceConfigStore][fetchConfig] Data is empty.');
      }

      const config = normalizePricingData(data.getStripePriceOpenDataConfig);

      runInAction(() => {
        this.config = config;
      });
    } catch (error) {
      const typedError = error as Error;
      runInAction(() => {
        this.error = typedError;
      });
      logError(typedError);
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }
}
